export const getters = {
  attributsexclures(state) {
    return state.attributsexclures;
  },
  attributsexclure(state) {
    return state.attributsexclure;
  },
  pagination(state) {
    return state.pagination;
  },
};
